import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ReservaDeSangueCirurgia, SolicitacaoReservaDeSangue, ModalReservaDeSangue } from '@/types/_'
import { clearEmptyFields } from '@/utils/common'
import moment from 'moment'
import _ from 'lodash'
import { ReservaDeSangue as rsImp } from '@/types/core'

@Module({ namespaced: true, name: 'ReservaDeSangueStore' })
export default class ReservaDeSangueStore extends VuexModule {
  public modalReservaDeSangue: ModalReservaDeSangue = {
    reservaDeSangue: false,
  }

  public reservaDeSangueDisabled: boolean = false

  private reservaDeSangueDefault: ReservaDeSangueCirurgia = {
    aptoComAtencao: false,
    solicitacaoReservaDeSangue: {
      solicitacaoId: '',
      paciente: {
        cpf: '',
        dataNascimento: '',
        nome: '',
        nomeMae: '',
      },
      reacaoTransfusional: '',
      fibrinogenio: 0,
      plaquetas: 0,
      concentradoDeHemacias: {
        indicacoes: '',
        indicacoesEspecificar: '',
        quantidade: 0,
        filtrado: null,
      },
      concentradoDePlaquetas: {
        indicacoes: '',
        indicacoesEspecificar: '',
        quantidade: 0,
        filtrado: null,
      },
      plasmaFrescoCongelado: {
        indicacoes: '',
        indicacoesEspecificar: '',
        quantidade: 0,
      },
      criptoprecipitado: {
        indicacoes: '',
        indicacoesEspecificar: '',
        quantidade: 0,
      },
      ultimaTransfusao: '',
    },
  }

  public reservaDeSangue: ReservaDeSangueCirurgia = { ...this.reservaDeSangueDefault }

  reservaDeSangueImp: rsImp.IReservaDeSangue = new rsImp.ReservaDeSangue()

  @Mutation
  setReservaDeSangueDisabled(value: boolean) {
    this.reservaDeSangueDisabled = value
  }

  @Mutation
  clearQuantidade(params: any) {
    const { campo } = params
    this.reservaDeSangue.solicitacaoReservaDeSangue[campo].quantidade = 0
    if ('filtrado' in this.reservaDeSangue.solicitacaoReservaDeSangue[campo]) this.reservaDeSangue.solicitacaoReservaDeSangue[campo].filtrado = null
    if ('indicacoesEspecificar' in this.reservaDeSangue.solicitacaoReservaDeSangue[campo]) this.reservaDeSangue.solicitacaoReservaDeSangue[campo].indicacoesEspecificar = ''
  }

  @Mutation
  setShowModalReservaDeSangue(value: boolean) {
    this.modalReservaDeSangue.reservaDeSangue = value
  }

  @Mutation
  setAptoComAtencao(value: boolean) {
    this.reservaDeSangue.aptoComAtencao = value
  }

  @Mutation
  clearConcentradoDeHemaciasEspecificar() {
    this.reservaDeSangue.solicitacaoReservaDeSangue.concentradoDeHemacias.indicacoesEspecificar = ''
  }

  @Mutation
  clearConcentradoDePlaquetasEspecificar() {
    this.reservaDeSangue.solicitacaoReservaDeSangue.concentradoDePlaquetas.indicacoesEspecificar = ''
  }

  @Mutation
  clearPlasmaFrescoCongeladoEspecificar() {
    this.reservaDeSangue.solicitacaoReservaDeSangue.plasmaFrescoCongelado.indicacoesEspecificar = ''
  }

  @Mutation
  clearCrioprecipitadoEspecificar() {
    this.reservaDeSangue.solicitacaoReservaDeSangue.criptoprecipitado.indicacoesEspecificar = ''
  }

  @Mutation
  clearReacaoTransfusionalEspecificar() {
    this.reservaDeSangue.solicitacaoReservaDeSangue.reacaoTransfusionalEspecificar = ''
  }

  @Mutation
  setReservaDeSangue(value: ReservaDeSangueCirurgia) {
    this.reservaDeSangue = value
  }

  @Mutation
  clearReservaDeSangue() {
    this.reservaDeSangue = {
      aptoComAtencao: false,
      solicitacaoReservaDeSangue: {
        solicitacaoId: '',
        paciente: {
          cpf: '',
          dataNascimento: '',
          nome: '',
          nomeMae: '',
        },
        reacaoTransfusional: '',
        fibrinogenio: 0,
        plaquetas: 0,
        concentradoDeHemacias: {
          indicacoes: '',
          indicacoesEspecificar: '',
          quantidade: 0,
          filtrado: null,
        },
        concentradoDePlaquetas: {
          indicacoes: '',
          indicacoesEspecificar: '',
          quantidade: 0,
          filtrado: null,
        },
        plasmaFrescoCongelado: {
          indicacoes: '',
          indicacoesEspecificar: '',
          quantidade: 0,
        },
        criptoprecipitado: {
          indicacoes: '',
          indicacoesEspecificar: '',
          quantidade: 0,
        },
        ultimaTransfusao: '',
      },
    }
  }

  @Mutation
  setSolicitacaoId(id: string) {
    this.reservaDeSangue.solicitacaoReservaDeSangue.solicitacaoId = id
  }

  @Mutation
  setSolicitacaoReservaDeSangue(solicitacaoCirurgia: SolicitacaoReservaDeSangue) {
    // eslint-disable-next-line
    for (const prop in solicitacaoCirurgia) {
      switch (prop) {
        case 'paciente':
          // eslint-disable-next-line
          for (const prop1 in solicitacaoCirurgia[prop]) {
            switch (prop1) {
              case 'dataNascimento':
                this.reservaDeSangue.solicitacaoReservaDeSangue.paciente[prop1] = moment(solicitacaoCirurgia[prop][prop1]).format('YYYY-MM-DD')
                break

              default:
                this.reservaDeSangue.solicitacaoReservaDeSangue.paciente[prop1] = solicitacaoCirurgia[prop][prop1]
                break
            }
          }
          break

        case 'ultimaTransfusao':
          this.reservaDeSangue.solicitacaoReservaDeSangue[prop] = moment(solicitacaoCirurgia[prop]).format('YYYY-MM')
          break

        case 'dataCirurgia':
        case 'dataDoExame':
          this.reservaDeSangue.solicitacaoReservaDeSangue[prop] = moment(solicitacaoCirurgia[prop]).format('YYYY-MM-DD')
          break

        default:
          this.reservaDeSangue.solicitacaoReservaDeSangue[prop] = solicitacaoCirurgia[prop]
          break
      }
    }
  }

  @Action
  async getReservaDeSangue(solicitacaoId: string) {
    try {
      const response = await this.reservaDeSangueImp.getReservaDeSangue(solicitacaoId)
      if (response.success) {
        this.context.commit('setSolicitacaoReservaDeSangue', response.data)
        this.context.commit('setSolicitacaoId', solicitacaoId)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async putReservaDeSangue(solicitacaoId: string) {
    const clearedFields = clearEmptyFields({ ...this.reservaDeSangue.solicitacaoReservaDeSangue })
    const params: any = {
      solicitacaoId,
      aptoComAtencao: this.reservaDeSangue.aptoComAtencao,
      solicitacaoReservaDeSangue: clearedFields,
      paciente: {
        nomeMae: this.reservaDeSangue.solicitacaoReservaDeSangue.paciente.nomeMae,
      },
    }

    const response = await this.reservaDeSangueImp.putReservaDeSangue(params)
    return response
  }
}
